export {
  OneColumnSearchResultPage,
  TireSearchGuidedNavigation,
  BOTSearchResult,
  TireResultList,
  GenericPromotionBlock,
  BOTTireComparePanel,
  BOTRecommendedSearchResult
} from '../OneColumnSearchResultPage'
export {
  BOTGlobalSearchSummary,
  BOTGlobalSearch,
  BOTBrandsSearchResults,
  BOTProductSearchResults,
  BOTServicesSearchResults,
  BOTArticlesSearchResults,
  BOTBreadcrumbBackGlobalSearch,
  BOTGlobalSearchBreadcrumbs,
  BOTRefinementMenu,
  BOTGuidedNavigation
} from '../GlobalSearch'
